import { CheckCircle, X } from "lucide-react";

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SubscriptionCancelldModal({
  isOpen,
  onClose,
}: SubscriptionModalProps) {
  if (!isOpen) return null;

  return (
    <div className="tailwind-prefix">
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          onClick={onClose}
        />

        {/* Modal */}
        <div style={{
            border:"1px solid #1e293b"
        }} className="relative max-w-md w-full mx-4 rounded-2xl bg-slate-900 p-8 shadow-2xl ">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 border-0 bg-transparent text-gray-400 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>

          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div style={{
                border:"1px solid #22c55e3e"
            }} className="rounded-full p-4 bg-green-500/10 ">
              <CheckCircle
                size={48}
                className="text-green-500"
                strokeWidth={2}
              />
            </div>
          </div>

          {/* Content */}
          <div className="text-center">
            <h2 className="text-2xl text-white mb-3 font-semibold">
              Subscription Canceled Successfully
            </h2>

            <p className="text-gray-400 mb-8 text-sm leading-relaxed">
  Your subscription has been canceled successfully.
  <br />
  You can still view your connected contracts.
</p>


            {/* Action button */}
            <button
            style={{
                border:"1px solid #334155"
            }}
              onClick={onClose}
              className="w-full   py-3 px-6 rounded-lg font-medium   bg-slate-800 text-white hover:bg-slate-700 transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
